import React from "react";
import { useTranslation } from "../../context/TranslationContext";
import { Globe } from "lucide-react";

type LanguageSelectorProps = {
  isScrolled?: boolean;
};

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  isScrolled = false,
}) => {
  const { language, setLanguage } = useTranslation();

  return (
    <div className="relative group">
      <button
        className={`flex text-black items-center gap-2 px-3 py-2 text-sm font-medium transition-colors duration-300 hover:text-primary`}
        aria-label="Select language"
      >
        <Globe className="w-4 h-4" />
        <span>{language.toUpperCase()}</span>
      </button>
      <div
        className={`absolute right-0 mt-2 w-24 bg-neutral rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50`}
      >
        <div className="py-1">
          <button
            className={`w-full px-4 py-2 text-sm text-left hover:bg-neutral/10 ${
              language === "en" ? "text-primary font-medium" : "text-white"
            }`}
            onClick={() => setLanguage("en")}
          >
            English
          </button>
          <button
            className={`w-full px-4 py-2 text-sm text-left hover:bg-neutral/10 ${
              language === "de" ? "text-primary font-medium" : "text-white"
            }`}
            onClick={() => setLanguage("de")}
          >
            Deutsch
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
